<template>
  <div class="box">
    <section class="select" style="min-width: 800px">
      <div class="top">
        <span
          :class="{ god: item.value === block ? true : false }"
          v-for="item in tops"
          :key="item.value"
          @click="all(item.value)"
          >{{ item.name }}</span
        >
      </div>
    </section>
      <div  class="mind">
        <div class="mind-one">
          <div  class="mind-one-top" v-if="block === 1" >
            <span>
              <Input
                v-model.trim="code"
                placeholder="订单编号"
                style="width: 280px; height: 30px;padding-left:20px"
              ></Input
            ></span>
            <span>
              <Input
                v-model.trim="partMsg"
                placeholder="配件编码/配件名称"
                style="width: 270px; height: 30px; margin: 0 20px"
              ></Input
            ></span>
            <span>
              <Select
                v-model="userNames"
                class="w100 mr10"
                clearable
                filterable
                remote
                style="width: 250px; height: 30px"
                placeholder="店铺名称"
                :loading="remoteloading"
                @on-change="getOnes"
                label-in-value
              >
                <Option
                  v-for="item in company"
                  :value="item.shopId"
                  :key="item.shopId"
                  >{{ item.shopName }}</Option
                >
              </Select>
            </span>
            <span style="margin-left: 20px">
              <Date-picker              
                type="daterange"
                placement="bottom-end"
                placeholder="选择下单日期"
                style="width: 300px"
                format="yyyy-MM-dd"
                class="w160"
                v-model="value3"
                @on-change="changeCompanyDate"
                clearable
              ></Date-picker
            ></span>
             <span style="width:200px"></span>
            <Button @click="reset " class="search reset" v-has="'WSS-2002-search'">重置</Button>
            <Button @click="search" class="search" v-has="'WSS-2002-search'">查询</Button>

            <span style="margin-left: 20px">
              <Select
               placeholder="订单状态"
                filterable  
                v-model="model1"
                style="width: 260px; height: 30px"
                @on-change="statusSelection"
              >
                <Option
                  v-for="item in orderStatus"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.name }}</Option
                >
              </Select></span
            >
             <span style="margin-left: 20px">
              <Select
               placeholder="下单员"
                filterable  
                v-model="model3"
                style="width: 270px; height: 30px"
                @on-change="oesersSelection"
              >
                <Option
                  v-for="item in orders"
                  :value="item.id"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select></span
            >
              <span style="margin-left: 20px">
              <Select
               placeholder="订单来源"
               filterable 
                v-model="model2"
                style="width: 250px; height: 30px;  position: relative"
                @on-change="sourceSelection"
              >
                <Option
                  v-for="item in orderSource"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.name }}</Option
                >
              </Select></span>
          </div>
          <div  class="mind-one-top" v-if="block === 6" >
            <span>
              <Input
                v-model.trim="salesfrom.code"
                placeholder="订单编号"
                style="width: 160px; height: 30px;padding-left:20px"
              ></Input
            ></span>
            <span>
              <Input
                v-model.trim="salesfrom.partMsg"
                placeholder="配件编码/配件名称"
                style="width: 320px; height: 30px; margin: 0 10px"
              ></Input
            ></span>
            <span>
              <Select
                v-model="salesfrom.userNames"
                class="w100 mr10"
                clearable
                filterable
                remote
                style="width: 320px; height: 30px;position: relative"
                placeholder="店铺名称"
                :loading="remoteloading"
                @on-change="getOnes6"
              >
                <Option
                  v-for="item in companytk"
                  :value="item.id"
                  :key="item.id"
                  >{{ item.tenantShortName }}</Option
                >
              </Select>
            </span>
             <span style="margin-left: 20px">
              <Select
                v-model="salesfrom.model1"
                clearable
                style="width: 320px; height: 30px;position: relative"
                placeholder='订单状态'
                @on-change="statusSelectiontk"
              >
                <Option
                  v-for="item in orderStatusth"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.name }}</Option
                >
              </Select></span
            >
            <Button @click="searchtk" class="search">搜索</Button>
          </div>
          <div  class="mind-one-top" v-if="block === 7" >
            <span>
              <Input
                v-model.trim="claim.code"
                placeholder="订单编号"
                style="width: 280px; height: 30px;padding-left:20px"
              ></Input
            ></span>
            <span>
              <Input
                v-model.trim="claim.part"
                placeholder="配件编码/配件名称"
                style="width: 320px; height: 30px; margin: 0 10px"
              ></Input
            ></span>
            <span>
              <Select
                v-model="claim.userNames"
                class="w100 mr10"
                clearable
                filterable
                remote
                style="width: 320px; height: 30px;position: relative"
                placeholder="店铺名称"
                :loading="remoteloading"
                @on-change="getOnes6"
              >
                <Option
                  v-for="item in company"
                  :value="item.shopId"
                  :key="item.shopId"
                  >{{ item.shopName }}</Option
                >
              </Select>
            </span>
            <span>
              <Select
                v-model="claim.state"
                class="w100 mr10"
                clearable
                filterable
                remote
                style="width: 320px; height: 30px;position: relative;padding-left:20px"
                placeholder="理赔单状态"
                @on-change="getOnes6"
              >
                <Option
                  v-for="item in claimstateList"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.name }}</Option
                >
              </Select>
            </span>
            <Button @click="searchtk" class="search">搜索</Button>
          </div>
            <Spin fix v-if="show">
              <Icon type="load-c" size="18" class="demo-spin-icon-load"></Icon>
              <div>Loading</div>
            </Spin>
          <div class="table"  style="padding-top:20px">
            <vxe-table
              ref="xTable"
              auto-resize
              :data="tableData"
              align="center"
              style="margin-top:20px;"
              class="mytable-style"
              :cell-style="cellStyle"
              :span-method="colspanMethod1"
              :expand-config="{
                labelField: 'name',
                expandAll: true,
                visibleMethod: expandVisibleMethod
              }"
            >
              <vxe-column type="expand" width="0">
                <template v-slot:content="{ row }">
                  <vxe-table
                    align="center"
                    max-width="1060"
                    border
                    class="mytable-scrollbar"
                    :data="row.children"
                    :show-header="false"
                    :span-method="colspanMethod"
                  >
                    <vxe-column  field="pictureUrl" title="Role" :width="block === 1 || block === 5?'8%':'10%'" >
                      <template v-slot="{ row }">
                        <img
                          v-if="row.pictureUrl"
                          style="width: 80px;height:80px;border:none"
                          :src="row.pictureUrl"
                          alt=""
                        />
                        <img
                          v-else
                          style="width: 80px;height:80px;border:none"
                          src="https://img.g-part.cn/prod/wss/default_null.png"
                          alt=""
                        />
                      </template>
                    </vxe-column>
                    <vxe-column style="border:none" field="partName" title="Address" width="20%" align="left" >
                      <template v-slot="{ row }">
                        <!-- <div class="w11"> -->
                        <!-- <div class="w12"> -->
                        <div class="w14">
                        <span v-if="row.partQualityType" class="ycj">
                          {{ row.partQualityType }}</span>
                        <span v-else class="ycj">{{row.qualityType}}</span>
                        <span> {{ row.partName }}</span>
                        </div>
                        <ul class="safeguard">
                           <li >
                             <span>服务：</span>
                             <!-- <p>正品保证</p> -->
                           </li>
                           <li v-if="row.genuineGuarantee">
                             <span class="iconfont icon-a-lujing153"></span>
                             <!-- <p>正品保证</p> -->
                           </li>
                           <li v-if="row.technicalSupport">
                             <span class="iconfont icon-a-ziyuan4"></span>
                             <!-- <p>技术支持</p> -->
                           </li>
                           <li v-if="row.warrantyService">
                             <span class="iconfont icon-a-ziyuan5"></span>
                             <!-- <p>保修服务</p> -->
                           </li>
                           <li v-if="row.returnPromise">
                             <span class="iconfont icon-a-ziyuan21"></span>
                             <!-- <p>退换货承诺</p> -->
                           </li>
                        </ul>
                      </template>
                    </vxe-column>
                    <vxe-column title="Address" width="10%">
                      <template v-slot="{ row }">
                        <span > {{ row.shipCity }}{{ row.shipStore }}</span>
                      </template>
                    </vxe-column>
                    <vxe-column title="Address" width="10%">
                      <template v-slot="{ row }">
                        <span v-show="!refundth"> {{ row.partNum}}</span>
                        <span v-show="row.type==1"> {{ row.moneybackNum}}</span>
                        <span v-show="row.type==2 || block === 7"> {{ row.refundNum}}</span>
                      </template>
                    </vxe-column>
                    <vxe-column title="Address" width="12%"> >
                      <template v-slot="{ row }">
                        <div class="ccc" v-if="block !== 7">
                          {{ '￥' + row.price }}
                        </div>
                        <div class="ccc" v-if="block === 7">
                          {{ '￥' + row.refundPrice }}
                        </div>
                      </template>
                    </vxe-column>
                    <vxe-column title="Address" width="10%" style="border:none;" class="w33" v-if="block !== 7">
                      <template v-slot="{ row }">
                        <span> {{ row.goodsFlag }}</span>
                      </template>
                    </vxe-column>
                    <vxe-column title="Address" width="10%" style="border:none;" class="w33" v-if="block === 1 || block === 5">
                      <template v-slot="{row}">
                        <router-link
                          rel="opener"
                          target="_blank"
                          :to="{
                            path: '/claim',
                            query: { ordersId:  row.rowId, ordersDetailId:row.id,type:0 }
                          }"
                          style="color:#377CF1"
                          v-if="!row.claimOrdersData && (row.rowState.value === 5 || row.rowState.value === 16)"
                          >理赔申请</router-link
                        >
                        <section v-if="row.claimOrdersData && row.claimOrdersData.state === 16">
                          <Button type="primary"  @click = "confirm(row)">撤销理赔</Button> 
                          <router-link
                            rel="opener"
                            target="_blank"
                            :to="{
                              path: '/claim',
                              query: { ordersId: row.rowId, ordersDetailId:row.claimOrdersData.ordersDetailId,code:row.claimOrdersData.ordersCode,type:1 }
                            }"
                            class="route"
                            >查看理赔</router-link
                          >
                        </section>
                        <!-- 卖家同意 oms没有返回-->
                        <section v-if="row.claimOrdersData && row.claimOrdersData.state === 17 && !row.claimOrdersData.claimManageStatus">
                          <Button type="primary" @click = "confirm(row)">撤销理赔</Button>
                          <router-link
                            rel="opener"
                            target="_blank"
                            :to="{
                              path: '/claim',
                              query: { ordersId: row.rowId, ordersDetailId:row.claimOrdersData.ordersDetailId,code:row.claimOrdersData.ordersCode,type:1 }
                            }"
                            class="route"
                            >查看理赔</router-link
                          >
                        </section>
                        <!-- 卖家同意 oms有返回-->
                        <section v-if="row.claimOrdersData && row.claimOrdersData.state === 17 && row.claimOrdersData.claimManageStatus">
                          <div>{{claimList[row.claimOrdersData.claimManageMode]}}</div>
                          <Button style="color:#377CF1" @click="getFinish(row)">{{claimReviceList[row.claimOrdersData.claimManageMode]}}</Button>
                        </section>
                        <!-- 理赔完成 oms要有返回 -->
                        <section v-if="row.claimOrdersData && row.claimOrdersData.state === 5 && row.claimOrdersData.claimManageStatus">
                          <div>{{claimList[row.claimOrdersData.claimManageMode]}}</div>
                          <div style="color: green">理赔完成</div>
                        </section>
                        <!-- 已拒绝 -->
                        <section v-if="row.claimOrdersData && row.claimOrdersData.state === 13">
                          <div>
                            <router-link
                              rel="opener"
                              target="_blank"
                              :to="{
                                path: '/claim',
                                query: { ordersId:  row.rowId, ordersDetailId:row.id,type:0 }
                              }"
                              style="color:#377CF1"
                              >理赔申请</router-link
                            >
                          </div>
                          <div>
                            <router-link
                              rel="opener"
                              target="_blank"
                              :to="{
                                path: '/claim',
                                query: { ordersId: row.rowId, ordersDetailId:row.claimOrdersData.ordersDetailId,code:row.claimOrdersData.ordersCode,type:1 }
                              }"
                              style="color:red"
                              >理赔拒绝</router-link
                            >
                          </div>
                        </section>
                        <!-- 已撤销 -->
                        <section v-if="row.claimOrdersData && row.claimOrdersData.state == 12">
                          <router-link
                            rel="opener"
                            target="_blank"
                            :to="{
                              path: '/claim',
                              query: { ordersId:  row.rowId, ordersDetailId:row.id,type:0 }
                            }"
                            style="color:#377CF1"
                            >理赔申请</router-link
                          >
                        </section>
                      </template>
                    </vxe-column>
                    <vxe-column title="Address" width="10%" style="border:none;" class="w33" v-if="block === 7">
                      <template v-slot="{row}">
                        <section v-if="row.rowState.value === 16">
                          <Button type="primary"  @click = "confirm(row)">撤销理赔</Button>
                          <!-- <router-link
                            rel="opener"
                            target="_blank"
                            :to="{
                              path: '/claim',
                              query: { ordersId: row.originalOrdersData.ordersId, ordersDetailId:row.id,code:row.ordersCode,type:1 }
                            }"
                            class="route"
                            >查看理赔</router-link
                          > -->
                          <span class="route" style="cursor:pointer" @click="go(row,1)">查看理赔</span>
                        </section>
                        <!-- 卖家同意 oms没有返回-->
                        <section v-if="row.rowState.value === 17 && !row.claimManageStatus">
                          <Button type="primary"  @click = "confirm(row)">撤销理赔</Button>
                          <!-- <router-link
                            rel="opener"
                            target="_blank"
                            :to="{
                              path: '/claim',
                              query: { ordersId: row.originalOrdersData.ordersId, ordersDetailId:row.id,code:row.ordersCode,type:1 }
                            }"
                            class="route"
                            >查看理赔</router-link
                          > -->
                          <span class="route" style="cursor:pointer" @click="go(row,1)">查看理赔</span>
                        </section>
                        <!-- 卖家同意 oms有返回-->
                        <section v-if="row.rowState.value === 17 && row.claimManageStatus">
                          <!-- <div>处理方式（后端返回）</div> -->
                          <div>{{claimList[row.claimManageMode]}}</div>
                          <Button style="color:#377CF1" @click="getFinish(row)">{{claimReviceList[row.claimManageMode]}}</Button>
                        </section>
                        <!-- 理赔完成 oms要有返回 -->
                        <section v-if="row.rowState.value === 5 && row.claimManageStatus">
                          <div>{{claimList[row.claimManageMode]}}</div>
                          <div style="color: green">理赔完成</div>
                        </section>
                        <!-- 已拒绝 -->
                        <section v-if="row.rowState.value === 13">
                          <div>
                            <!-- <router-link
                              rel="opener"
                              target="_blank"
                              :to="{
                                path: '/claim',
                                query: { ordersId:  row.originalOrdersData.ordersId, ordersDetailId:row.originalOrdersData.ordersDetailId,type:0 }
                              }"
                              style="color:#377CF1"
                              >理赔申请</router-link
                            > -->
                            <span style="color:#377CF1;cursor:pointer" @click="go(row,0)">理赔申请</span>
                          </div>
                          <div>
                            <!-- <router-link
                              rel="opener"
                              target="_blank"
                              :to="{
                                path: '/claim',
                                query: { ordersId: row.originalOrdersData.ordersId, ordersDetailId:row.id,code:row.ordersCode,type:1 }
                              }"
                              style="color:red"
                              >理赔拒绝</router-link
                            > -->
                            <span style="color:red">理赔拒绝</span>
                          </div>
                        </section>
                        <section v-if="row.rowState.value === 12">
                          <!-- <router-link
                            rel="opener"
                            target="_blank"
                            :to="{
                              path: '/claim',
                              query: { ordersId:  row.originalOrdersData.ordersId, ordersDetailId:row.originalOrdersData.ordersDetailId,type:0 }
                            }"
                            style="color:#377CF1"
                            >理赔申请</router-link
                          > -->
                          <span style="color:#377CF1;cursor:pointer" @click="go(row,0)">理赔申请</span>
                        </section>
                      </template>
                    </vxe-column>
                    <vxe-column field="rowNums" :width="block === 1 || block === 5?'10%':'14%'" >
                      <template v-slot="{ row }">
                        <div v-if="block !== 7">
                          <div v-if="!refundth">
                            <div>商品金额：{{ '￥' + row.money }}</div>
                            <div>
                            实付金额：<span
                              style="color: red; font-weight: 700"
                              >{{ '￥' + row.payMoney }}</span
                            >
                          </div>
                          <!-- <div>含运费：</div> -->
                          </div>
                          <div v-else>
                            <div v-show="row.type == 3|| row.type == 2">退货金额<span style="color: red; font-weight: 700">{{ '￥' + row.afterSaleAmount }}</span></div>
                            <div v-show="row.type==1">退款金额<span style="color: red; font-weight: 700">{{ '￥' + row.afterSaleAmount }}</span></div>
                          </div>
                        </div>
                        <div v-else>
                          <div>理赔金额：{{ '￥' + row.refundAmount }}</div>
                        </div>
                      </template>
                    </vxe-column>
                    <vxe-column field="rowNums" :width="block === 1 || block === 5?'10%':'14%'" >
                      <template v-slot="{ row }">
                        <router-link
                          v-if="row.state == 1"
                          rel="opener"
                          target="_blank"
                          :to="{
                            path: '/payOrder',
                            query: {
                              ordeNumber: JSON.stringify(row.rowId.split(','))
                            }
                          }"
                          class="fh"
                          style="display: inline-block"
                          >付款</router-link
                        >
                   
                        <div
                          v-if="row.state == 1"
                          style="color: #377CF1;cursor: pointer;"
                          @click="cancellationOrder(row)"
                        >取消订单</div>
                        <div
                          v-if="row.state == 3 && row.isReceiver == 1"
                          class="fh"
                          style="margin:0 auto"
                          @click="receiving(row)"
                        >收货</div>
                        <router-link
                          v-if="row.refundType == 1 && row.state == 9"
                          rel="opener"
                          target="_blank"
                          :to="{
                            path: '/refunddispose',
                            query: { drawback: row.refundId }
                          }"
                          class="fh"
                          style="display: block;margin:0 auto;margin-bottom:10px;"
                          >查看申请</router-link
                        >                      
                        <div
                          v-if="row.refundType == 1 && row.state == 9 "
                          class="fh"
                          style=" display: inline-block"
                          @click="revokeApplication(row)">撤销申请</div>                                               
                         <router-link
                          v-if="row.refundType == 2 && row.state == 10"
                          rel="opener"
                          target="_blank"
                          :to="{
                            path: '/salesreturn',
                            query: { drawback: row.refundId,refundType: row.refundType }
                          }"
                          class="fh"
                          style="display: block;margin:0 auto;margin-bottom:10px;"
                          >查看申请</router-link
                        >                      
                        <div
                          v-if="row.refundType == 2 && row.state == 10"
                          class="fh"
                          style=" display: inline-block"
                          @click="revokeApplication(row)">撤销申请</div>
                        <div
                          v-if="row.refundType == 3 && row.state == 10"
                          class="fh"
                          style=" display: inline-block"
                          @click="revokeApplication(row)">撤销申请</div>
                        <router-link
                          v-if="row.refundType == 3 && row.state == 10"
                          rel="opener"
                          target="_blank"
                          :to="{
                            path: '/salesreturn',
                            query: { drawback: row.refundId,refundType: row.refundType }
                          }"
                          class="fh"
                          style="display: block;margin:0 auto;margin-bottom:10px;"
                          >查看申请</router-link
                        >
                        <router-link
                          v-if="row.refundType == 3 && row.state == 9"
                          rel="opener"
                          target="_blank"
                          :to="{
                            path: '/salesreturn',
                            query: { drawback: row.refundId,refundType: row.refundType }
                          }"
                          class="fh"
                          style="display: block;margin:0 auto;margin-bottom:10px;"
                          >查看申请</router-link
                        > 
                        <div
                          v-if="row.refundType == 3 && row.state == 9"
                          class="fh"
                          style=" display: inline-block"
                          @click="revokeApplication(row)">撤销申请</div>
                        <router-link
                          v-if="row.state == 2 && !refundth"
                          rel="opener"
                          target="_blank"
                          :to="{
                            path: '/refunddispose',
                            query: { details: row.rowId }
                          }"
                          style="width:70px;color: #0074ff; display: block;margin:0 auto;"
                          >申请退款</router-link>
                          <!-- <div style="color: #0074ff; display: block"  v-if="row.state == 2&&!refundth" @click="applyForRefund(row)">申请退款</div> -->
                          <!-- <div style="color: #0074ff; display: block"  v-if="row.state == 5&&!refundth" @click="applyForSales(row)">申请退货</div> -->
                        <router-link
                          v-if="row.state == 5 && !refundth && row.isAfterSale == 1"
                          rel="opener"
                          target="_blank"
                          :to="{
                            path: '/salesreturn',
                            query: { details: row.rowId }
                          }"
                          style="width:70px;color: #0074ff; display: block;margin:0 auto;"
                          >申请售后</router-link>
                          <!-- target="_blank" -->
                          <!-- rel="opener" -->
                          <router-link
                          v-if="block === 6 && row.isSellerRefunded == 1 "
                          rel="opener"
                          target="_blank"
                          :to="{
                            path: '/saleshandlereturn',
                            query: { drawback:  row.rowId }
                          }"
                          style="width:70px;color: #377CF1; display: block;margin:0 auto;"
                          >订单详情</router-link
                        >
                         <!-- 买家发起退款isSellerRefunded  ==0 -->
                          <!-- <router-link
                          v-if="block === 6  && row.isSellerRefunded == 0"
                           rel="opener"
                           target="_blank"
                          :to="{
                            path: '/refunddispose',
                            query: { drawback: row.id, }
                          }"
                          style="width:70px;color: #0074ff; display: block;margin:0 auto;"
                          >订单详情</router-link
                        > -->
                          <router-link
                          v-if="block === 6  && row.isSellerRefunded == 0 && row.refundType == 1"
                           rel="opener"
                           target="_blank"
                          :to="{
                            path: '/refunddispose',
                            query: { drawback: row.rowId, }
                          }"
                          style="width:70px;color: #0074ff; display: block;margin:0 auto;"
                          >订单详情</router-link
                        >
                        <router-link
                          v-if="(block === 6  && row.isSellerRefunded == 0 && row.refundType == 2) || (block === 6  && row.isSellerRefunded == 0 && row.refundType == 3)"
                           rel="opener"
                           target="_blank"
                          :to="{
                            path: '/salesreturn',
                            query: { drawback: row.refundId,refundType: row.refundType }
                          }"
                          style="width:70px;color: #0074ff; display: block;margin:0 auto;"
                          >订单详情</router-link
                        >
                        <!-- <router-link
                          v-if="block === 7 "
                          rel="opener"
                          target="_blank"
                          :to="{
                            path: '/orderDetails',
                            query: { id: row.ordersChangeCode,orderId: row.originalOrdersData.ordersId,refundId:row.refundId }
                          }"
                          style="width:70px;color: #377CF1; display: block;margin:0 auto;"
                          >订单详情</router-link
                        > -->
                        <div v-if="block === 7 " style="width:70px;color: #377CF1;cursor:pointer;margin:0 auto;" @click="go(row,2)">订单详情</div>
                        <router-link
                          v-if="block !== 6 && block !== 7 "
                          rel="opener"
                          target="_blank"
                          :to="{
                            path: '/orderDetails',
                            query: { id: row.ordersCode,orderId: row.rowId,refundId:row.refundId }
                          }"
                          style="width:70px;color: #377CF1; display: block;margin:0 auto;"
                          >订单详情</router-link
                        >
                        <div
                          v-if="row.isAgain  == 1 && block !== 7"
                          class="fh fg"
                          style=" display: inline-block"
                          @click="buyagain(row)">再次购买</div>
                          <!-- <router-link
                          v-if="row.isAgain  == 1"
                          rel="opener"
                          target="_blank"
                          :to="{
                            path: '/buyAgain',
                            query: { details: row.id }
                          }"
                          style="width:70px;color: #0074ff; display: block;margin:0 auto;"
                          >再次购买</router-link> -->
                        <div v-if="row.state == 1">
                          <span>还剩</span>
                          <span style="color:red">{{row.min}}分{{row.sec}}秒</span>
                          <span style="cursor: pointer;">取消订单</span>
                        </div>
                        <div v-if="row.state == 3 && row.isReceiver == 1">
                          <span>还剩</span>
                          <span style="color:red">{{row.tday}}天{{row.thour}}小时{{row.tmin}}分{{row.tsec}}秒</span>
                          <span>自动收货</span>
                        </div>
                        <!-- <div v-if="row.state == 3">还剩2天收货</div> -->
                      </template>
                    </vxe-column>
                  </vxe-table>
                </template>
              </vxe-column>
              <vxe-column class-name="aaaa" title="商品信息" :width="block === 1 || block === 5?'28%':'30%'">
                <template v-slot="{ row }">
                      <div class="rowBox">
                        <span style="font-weight:700;font-size:12px;text-align: left;" v-show="block !== 7">订单号： {{ row.code }}</span>
                        <span style="font-weight:700;font-size:12px;text-align: left;" v-show="block === 7">理赔单号: {{ row.code }}</span>
                        <span :style="[{color: row.pushStatus == 2 ? '#F62B4E' : '#47C460'}]" class="iconfont icon-zhifeiji_fabu pos"></span>
                      </div>
                      <div style="text-align: left;margin-left:25px">
                        <span style="font-size:12px;margin-right:10px"> {{ row.buyShopName }}</span>
                        <xiaopei :oppositeTenantId="row.tenantId" :orderId="row.id">
                          <!-- {{row}} -->
                            <i class="iconfont icon-a-lujing162"></i>
                        </xiaopei>
                      </div>
                </template>
              </vxe-column>
              <vxe-column title="发货地" width="10%">
                <template v-slot="{ row }">
                    <span style="font-size:14px;" v-show="block !== 6 && block !== 7">下单员：{{row.createUname}}</span>
                </template>
              </vxe-column>
              <vxe-column title="数量" width="10%"> 
              </vxe-column>
              <vxe-column title="单价(元)" width="12%">
                <template v-slot="{ row }">
                    <span style="font-size:13px;">{{row.createTime}}</span>
                </template>
              </vxe-column>
              <vxe-column
                title="商品状态"
                width="10%"
                v-if="block !== 7"
              ></vxe-column>
              <vxe-column
                title="理赔申请"
                width="10%"
                v-if="block === 1 || block === 5 || block === 7"
              >
              </vxe-column>
              <vxe-column
                title="付款信息"
                :width="block === 1 || block === 5?'10%':'14%'"
                show-overflow="tooltip"
              >
                <template v-slot="{ row }">
                    <span v-if="refundth">{{row.cancelReason}}</span>
                    <span v-else style="margin-right:10px">{{row.state.name}}</span>
                </template>
              </vxe-column>
              <vxe-column title="交易操作" :width="block === 1 || block === 5?'10%':'14%'">
                <template v-slot="{ row }">
                  <a
                  v-if="!refundth&& block !== 7"
                    :href="
                      `${publicPath}wss-order/myWssOrder/simpleExportOrder?code=${row.code}&access_token=${token}`
                    "
                    class="iconfont icon-a-lujing296"
                    style="font-size: 14px"
                    title="导出"
                     v-has="'WSS-2002-export'"
                  ><i>导出</i></a>
                  <span v-if="((row.state.value === 3&&!refundth) || (row.state.value === 5&&!refundth)) && block !== 7" style="margin-left:20px;" @click="boughtPrint(row)" title="打印" class="iconfont icon-a-2" v-has="'WSS-2002-printer'"><i>打印</i></span>
                </template>
              </vxe-column>
              </vxe-table>
              <div  style="display: flex; justify-content: right;">
              <vxe-pager
                background
                :current-page.sync="page.current"
                :page-size.sync="page.size"
                @page-change="pageChange"
                :total="totalResult"
                :page-sizes="[30]"
                :layouts="[
                  'PrevJump',
                  'PrevPage',
                  'JumpNumber',
                  'NextPage',
                  'NextJump',
                  'Sizes',
                  'FullJump',
                  'Total'
                ]"
              >      
              </vxe-pager>
              <span  
              style="
                   height: 31px;
                   padding: 7px 10px;
                   border: 1px solid rgb(220, 222, 226);
                   border-radius: 4px;
                   margin-top: 8px;
                   line-height: 13px;
              ">30条/页</span>
              </div>
              
          </div>
        </div>
      </div>

    <boughtPrint ref="printZF" style="display: none"></boughtPrint>
    <Modal
      v-model="modal2"
      width="360"
      :closable="false"
      @on-visible-change="visible"
    >
      <div style="text-align: center">
        <div style="margin-bottom: 20px">
          <span> 您确认要取消订单么？取消订单后，不能恢复。</span>
        </div>
        取消原因：
        <Select v-model="cancel" label-in-value style="width: 200px" @on-change="cancelChange">
          <Option
            v-for="item in cancellation"
            :value="item.id"
            :key="item.id"
            >{{ item.itemName }}</Option
          >
        </Select>
      </div>
      <div slot="footer">
        <Button
          size="small"
          type="primary"
          class="yes"
          style="margin-right: 40px"
          @click="cancellationOK"
          >确定</Button
        >
        <Button
          size="small"
          type="primary"
          class="yes"
          style="margin-right: 70px"
          @click="modal2 = false"
          >取消</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
// import headerTop from '@/views/base/common/header-top.vue'
import Cookies from 'js-cookie'
import { TOKEN_KEY } from '@/libs/util'
import urlObj from '@/config/env.js'
import boughtPrint from './components/boughtPrint.vue'
import {
  storeName,
  getSalesOrder,
  getDictionariesItemList,
  cancelOrder,
  orderTakeDelivery,
  revoke,
  applyForRefund,
  getapplyForRefund,
  getSalesReturn,
  buyshopstate,
  getOrderer
} from '@/api/business/bought.js'
import { getAgain } from '@/api/buyagain.js'
// import { awaken } from '@/api/xiaopei/shout.js'
import xiaopei from '@/views/xiaopei/index.vue'
import { cliamList, handleCliam, finishCliam } from '@/api/myweb/cliam'
export default {
  // mixins: [awaken],
  name: "bought",
  components: {
    // headerTop
    xiaopei,
    boughtPrint
  },
  data() {
    return {
      refundth:false, //退款退货
      companytk:[], //退款店铺名称
      claim: {
        code:'',
        part:'',
        userNames:'',
        state:''
      }, //理赔参数
      claimstateList: [
        { value: '0',name:'所有' },
        { value: '1',name:'理赔中' },
        { value: '2',name:'理赔完成' },
        { value: '3',name:'理赔拒绝' },
        { value: '4',name:'已撤销' }
      ],
      claimReviceList: ['','收到原货','收到换货','收到退货','已经销毁'],
      claimList: ['','原货退还','换货处理','退货处理','原物销毁'],
      // 下面是何龙写的
      token: Cookies.get(TOKEN_KEY),
      // token: JSON.parse(window.sessionStorage.getItem('vuex')).user.token,
      show: false, // loading
      ordersCode: '', // 订单号
      cancellation: [],
      c: '',
      modal2: false,
      publicPath: urlObj.wss,
      // deliverState: true, // 发货状态
      userName: '', // 店铺名称
      code: '',
      partMsg: '',
      remoteloading: false,
      block: 1,
      model1: '',
      model2: '', // 订单来源
      model3: '', // 下单元
      cancel: '',
      userNames: '',
      cancelStatus: '',
      time: [],
      salesfrom:{
        code:'',
        partMsg:'',
        userNames:'',
        model1:'',
        model3:''
      }, // 退货退款的数据
      value3:'',
      orderStatusth:[
        {
          value: 1,
          name: '已退款'
        },
         {
          value: 2,
          name: '已退货'
        },
      ], //订单状态
      company: [], // 店铺查询的数据
      tops: [
        {
          value: 1,
          name: '所有订单'
        },
        {
          value: 2,
          name: '待付款'
        },
        {
          value: 3,
          name: '待发货'
        },
        {
          value: 4,
          name: '待收货'
        },
        {
          value: 5,
          name: '交易完成'
        },
        {
          value: 6,
          name: '退款/退货'
        },
        {
          value: 7,
          name: '理赔申请'
        }
      ],
      orderStatus: [
        {
          value: -1,
          name: '全部'
        },
        {
          value: 1,
          name: '待付款'
        },
        {
          value: 2,
          name: '待发货'
        },
        {
          value: 3,
          name: '待收货'
        },
        {
          value: 5,
          name: '交易完成'
        },
        {
          value: 6,
          name: '交易取消'
        },
        {
          value: 11,
          name: '交易关闭'
        }
      ],
      orderSource:[
        {
          value: -1,
          name: '全部'
        },
        {
          value: 1,
          name: '极联web'
        },
        {
          value: 2,
          name: '线下开单'
        },
        {
          value: 3,
          name: '极联web-询价单'
        },
      ],
      orders:[],
      tableData: [],
      cityList: [],
      page: {
        current: 1,
        size: 30
      },
      totalResult: 0
    }
  },
  created() {
    this.tableList(1)
    this.getOne()
    this.getDictionariesItemList()
    this.buyshopstate()
    this.getOrderer()
  },

  methods: {
    go(row,type) {
      let routeData
      if(type === 0){
        // 理赔申请
        routeData = this.$router.resolve({
          name: 'claim',
          query: { ordersId:  row.originalOrdersData.ordersId, ordersDetailId:row.originalOrdersData.ordersDetailId,type:0 }
        })
      }else if(type === 1){
        // 查看理赔
        routeData = this.$router.resolve({
          name: 'claim',
          query: { ordersId: row.originalOrdersData.ordersId, ordersDetailId:row.id,code:row.ordersCode,type:1 }
        })                       
      }else{
        // 跳转详情
        routeData = this.$router.resolve({
          name: 'orderDetails',
          query: { id: row.ordersChangeCode,orderId: row.originalOrdersData.ordersId,refundId:row.refundId }
        }) 
      }
      window.open(routeData.href,'_blank')
    },
    confirm(val) {
      this.$Modal.confirm({
        title: '是否要撤销申请？',
        onOk: async() => {
          let data = {}
          if(this.block !== 7){
            data = {
              ordersId: val.rowId,
              claimDetailId: val.claimOrdersData.ordersDetailId,
              claimOrdersCode: val.claimOrdersData.ordersCode,
              type: 3
            }
          }else{
            data = {
              ordersId: val.originalOrdersData.ordersId,
              claimDetailId: val.id,
              claimOrdersCode: val.ordersCode,
              type: 3
            }
          }
          let res = await handleCliam(data)
          console.log(res)
          if(res.status){
            this.$Message.success('理赔已撤销！')
            location.reload() 
          }
        },
        onCancel: () => {}
      });
    },
    getFinish(val) {
      this.$Modal.confirm({
        title: this.block === 7?`是否要${this.claimReviceList[val.claimManageMode]}`:`是否要${this.claimReviceList[val.claimOrdersData.claimManageMode]}`,
        onOk: async() => {
          let ordersCode
          if(this.block === 7) {
            ordersCode = val.ordersCode
          }else{
            ordersCode = val.claimOrdersData.ordersCode
          }
          let res = await finishCliam({ordersCode})
          if(res.status){
            this.$Message.success('理赔处理完成！')
            location.reload()
          }
        },
        oncancel:{}
      })  
    },
    // 店铺名称
    async buyshopstate(){
      const res=await buyshopstate({
        shopName:'',
        state:1
      })
      if(res.status){
        this.companytk=res.data.list
      }
    },
    // 获取下单员
   async getOrderer(){
      const res = await getOrderer()
      console.log(res);
      if(res.status){
        this.orders = res.data
      }
    },
    // 退货的接口
    async applyForSales(row){
      let res = await getapplyForRefund(row.rowId)
        if(res.data){
      // const { href } = this.$router.resolve({
      //   path: '/refunddispose',
      //   query: { details: row.id }
      // });
      this.$router.push({
        path: '/salesreturn',
        query: { details: row.rowId }
      })
      }
    },
    //  async applyForRefund(row) {
    //   let res = await applyForRefund(row.id)
    //   if(res.data){
    //   // const { href } = this.$router.resolve({
    //   //   path: '/refunddispose',
    //   //   query: { details: row.id }
    //   // });
    //   this.$router.push({
    //     path: '/refunddispose',
    //     query: { details: row.id }
    //   })
    //   }
      
    // },
    colspanMethod1 ({ _rowIndex, _columnIndex }) {
      //  if (_rowIndex % 2 === 0||_rowIndex % 2 === 1) {
      //     if (_columnIndex === 2) {
      //         return { rowspan: 1, colspan: 2 }
      //     } else if (_columnIndex === 3) {
      //       return { rowspan: 0, colspan: 0 }
      //     }
      //   }
      },
    // 切换
    all(a) {
      this.block = a
        if(a==1) {
        this.code = ''
        this.partMsg = ''
        this.userNames = ''
        this.model1 = ''
        this.model2 = ''
        this.model3 = ''
      
      }
      this.claim = {
        code: "",
        part: "",
        userNames: "",
        state: ""
      }
      this.page.current=1
      this.page.size=30
      this.tableList(2)
    },
    // 搜索
    async search() {
      this.tableList(2)
    },
    searchtk(){
      this.tableList(2)
    },
    // 退货/退款的 (店铺名称)
    getOnes6(val) {
       if(val){
       this.salesfrom.userNames = val
      }
      // this.salesfrom.userNames = val
    },
    // 所有订单数据
    async tableList(num) {
      this.show = true
      let data1 = {
        createUid:this.salesfrom.model3,
        code: this.salesfrom.code,
        partMsg: this.salesfrom.partMsg,
        tenantId:this.salesfrom.userNames,
        businessState:1,
        status:this.salesfrom.model1,
        current: this.page.current,
        size: this.page.size,
      }
      let params = {
        current: this.page.current,
        size: this.page.size
      }
      let data = {
        code: this.code,
        partMsg: this.partMsg,
        startTime: this.time[0] == undefined || this.time[0] == '' ? '' : this.time[0] + ' 00:00:00',
        endTime: this.time[1] == undefined || this.time[1] == '' ? '' : this.time[1] + ' 23:59:59',
        shopId: this.userNames,
        createUid:this.model3
      }
      switch (this.block) {
        case 1:
          data.state = [this.model1]
          break
        case 2:
          data.state = [1]
          break
        case 3:
          data.state = [2]
          break
        case 4:
          data.state = [3, 4]
          break
        case 5:
          data.state = [5]
          break
      }
      if(this.block==6){
        const res=await getSalesReturn(data1)
        this.show = false
         if (res.status) {
        this.show = false
        this.refundth=true
        // this.page.current = res.data.current
        // this.page.size = res.data.size
        this.totalResult = res.data.total
        this.tableData = res.data.records
        if (num === 2) {
          this.$refs.xTable.reloadData(this.tableData)
        }
        this.tableData.filter(el => {
          let c = el.money
          let a = el.payMoney
          let state = el.state.value
          let ids = el.id
          let b = el.modifyMoney
          let r = el.refundId
          let s = el.refundType
          let h = el.afterSaleAmount
          let k = el.isAfterSale
          let d = el.isSellerRefunded
          el.rowNum = el.children.length
          let o = el.isReceiver
          let j = el.isAgain
          el.children.filter(el => {
            el.isSellerRefunded = d // 判断买卖双方哪家发起的
            el.rowNums = 1
            el.money = c
            el.payMoney = a
            el.state = state
            // el.id = ids
            el.rowId = ids
            el.refundType = s
            el.modifyMoney = b
            el.refundId = r
            el.afterSaleAmount = h
            el.isAfterSale = k
            el.isAgain = j
            el.isReceiver = o
          })
        })
      } 
      }else if(this.block === 7){
        let obj = {
          ordersCode: this.claim.code,
          partMsg:this.claim.part,
          tenantId:this.claim.userNames,
          businessState: 1
        }
        switch (this.claim.state){
          case ''|| '0' : break;
          case '1': obj.state = [16,17]; break;
          case '2': obj.state = [5]; break;
          case '3': obj.state = [12]; break;
          case '4': obj.state = [13]; break;
        }
        let res = await cliamList(obj,this.page)
        if(res.status) {
          this.show = false
          this.totalResult = res.data.total
          this.tableData = res.data.records
          if (num === 2) {
            this.$refs.xTable.reloadData(this.tableData)
          }
          // this.tableData.forEach(item => {
          //   item.children.forEach(i => {
          //     i.rowId = item.id
          //     i.rowState = item.state
          //   })
          // })
          this.tableData.filter(el => {
            let min = el.min
            let sec = el.sec
            let tday = el.tday
            let thour = el.thour
            let tmin = el.tmin
            let tsec = el.tsec
            let c = el.money
            let a = el.payMoney
            let b = el.modifyMoney
            let s = el.refundType
            // let state = el.state.value
            // let ids = el.id
            let r = el.refundId
            let k = el.isAfterSale
            let j = el.isAgain
            let o = el.isReceiver
            let ids = el.id
            let state = el.state
            el.rowNum = el.children.length
            el.children.filter(el => {
              el.rowNums = 1
              el.money = c
              el.payMoney = a
              // el.state = state
              // el.id = ids
              el.sec = sec
              el.min = min
              el.tday = tday
              el.thour = thour
              el.tmin = tmin
              el.refundType = s
              el.tsec = tsec
              el.modifyMoney = b
              el.refundId = r
              el.isAfterSale = k
              el.isAgain = j
              el.isReceiver = o
              el.rowState = state
              el.rowId = ids
            })
          })
        }
        console.log(this.tableData,'-----------');
      }else{
        let storeSource = JSON.parse(JSON.stringify(this.model2 == '' ? '-1' : this.model2))
        let storeState = JSON.parse(JSON.stringify(data.state == '' ? [-1] : data.state))
        data.source = storeSource 
        data.state = storeState
        let res = await getSalesOrder(params, {...data,...params})
        if (res.status) {
        this.show = false
        this.refundth=false
        // this.page.current = res.data.current
        // this.page.size = res.data.size
        this.totalResult = res.data.total
        this.tableData = res.data.records

        if (num === 2) {
          this.$refs.xTable.reloadData(this.tableData)
        }
        this.tableData.filter(el => {
          let min = el.min
          let sec = el.sec
          let tday = el.tday
          let thour = el.thour
          let tmin = el.tmin
          let tsec = el.tsec
          let c = el.money
          let a = el.payMoney
          let b = el.modifyMoney
          let s = el.refundType
          let state = el.state.value
          let ids = el.id
          let r = el.refundId
          let k = el.isAfterSale
          let j = el.isAgain
          let o = el.isReceiver
          let rowId = el.id
          const rowState = el.state
          el.rowNum = el.children.length
          el.children.filter(el => {
            el.rowNums = 1
            el.money = c
            el.payMoney = a
            el.state = state
            // el.id = ids
            el.sec = sec
            el.min = min
            el.tday = tday
            el.thour = thour
            el.tmin = tmin
            el.refundType = s
            el.tsec = tsec
            el.modifyMoney = b
            el.refundId = r
            el.isAfterSale = k
            el.isAgain = j
            el.isReceiver = o
            el.rowId = rowId
            el.rowState = rowState
          })
        })
      } else {
        this.show = false
      }
      }
      console.log(this.tableData);
    },
    // 重置列表
    reset(){
        this.salesfrom = {
        code:'',
        partMsg:'',
        userNames:'',
        model1:'',
        model3:''
      } 
      this.page = {
        current: 1,
        size: 30
      },
      this.value3 = ''
      this.code = ''
      this.partMsg = ''
      this.userNames = ''
      this.model1 = ''
      this.model3 = ''
      this.model2 = ''
      this.time = ''
      this.tableList(2)
    },
    // 订单状态选择
    statusSelection(value) {
      this.model1 = value
    },
    // 订单来源
    sourceSelection(value) {
      this.model2 = value
    },
    // 订单状态选择
    statusSelectiontk(value) {
      this.salesfrom.model1 = value
    },
    oesersSelection(value){
      console.log(value);
    },

    // 表格合并
    colspanMethod({ row, _rowIndex, column, visibleData }) {
      let fields = ['rowNums']
      let cellValue = row[column.property]
      if (cellValue && fields.includes(column.property)) {
        let prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]
        if (prevRow && prevRow[column.property] === cellValue) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && nextRow[column.property] === cellValue) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 }
          }
        }
      }
    },
    visible() {
      this.cancel = ''
    },
    // 时间的change事件
    changeCompanyDate(date) {
      this.time = date
      console.log(this.value3);
    },
    // 店铺数据
    async getOne() {
      this.remoteloading = true
      let res = await storeName()
      if (res.status) {
        this.company = res.data.list
        this.remoteloading = false
      }
    },
    getOnes(val) {
      if(val){
       this.userNames = val.value
      }
      
    },
    // 发货
    // deliver() {
    //   this.deliverState = false
    // },
    expandVisibleMethod({ row }) {
      return false
    },

    cellStyle({ rowIndex }) {
      if ([0, 1, 2, 3, 4, 5, 6, 7, 8, 9].includes(rowIndex)) {
        return {
          backgroundColor: '#ffffff'
        }
      }
    },
    // 分页事件
    pageChange({ currentPage, pageSize }) {
      console.log(currentPage,pageSize);
      // currentPage  页数
      // pageSize 当前页的条数
      this.page.current = currentPage
      this.page.size = pageSize
      this.tableList(2)
    },
    // 取消订单
    cancellationOrder(row) {
      this.modal2 = true
      this.ordersCode = row.rowId
    },
    // 数据字典接口
    async getDictionariesItemList() {
      let params = {}
      params.dictCode = 'QXYY'
      let res = await getDictionariesItemList(params)
      if (res.code === 0) {
        this.cancellation = res.data.records
      }
    },
    cancelChange(val) {
      if(val){
      this.cancelStatus = val.label
      }      
    },
    cancellationOK() {
      this.$Modal.confirm({
        title: '是否要取消订单',
        onOk: async () => {
          this.spinShow = true
          let params = {}
          params.cancelReason = this.cancelStatus
          params.orderId = this.ordersCode
          if(this.cancelStatus === ''){
            this.$Message.error('请填写取消原因')
            return
          }
          let res = await cancelOrder(params)
          if (res.status) {
            this.$Message.success('成功取消')
            this.modal2 = false
            this.tableList(2)
          }
          this.cancel = ''
        },
        onCancel: () => {
          this.$Message.warning('已取消')
        }
      })
    },
    //  撤销申请
    revokeApplication(row) {
      console.log(row);
      this.$Modal.confirm({
        title: '是否要撤销申请？',
        onOk: async () => {
          let res = await revoke(row.refundId + '/' + row.refundType)
          if (res.status) {
            this.$Message.success('撤销成功')
            this.tableList(2)
          }
        },
        onCancel: () => {
          this.$Message.warning('已取消')
        }
      })
    },
    // 收货
    receiving(row) {
      this.$Modal.confirm({
        title: '确认收货？',
        onOk: async () => {
          let params = {}
          params.orderId = row.rowId
          let res = await orderTakeDelivery(params)
          if (res.status) {
            this.tableList(2)
            this.$Message.success('已收货')
          }
        },
        onCancel: () => {
          this.$Message.warning('已取消')
        }
      })
    },
     async applyForRefund(row) {
      let res = await applyForRefund(row.rowId)
      if(res.data){
      // const { href } = this.$router.resolve({
      //   path: '/refunddispose',
      //   query: { details: row.id }
      // });
      this.$router.push({
        path: '/refunddispose',
        query: { details: row.rowId }
      })
      }
      
    },
    payment(row) {
      this.$router.push({
        path: '/payOrder',
        query: { ordeNumber: JSON.stringify(row.rowId.split(',')) }
      })
    },
    boughtPrint(row){
      console.log(row);
      // this.$refs.printZF.jjj(row.rowId)
      this.$refs.printZF.jjj(row.id)
    },
    // 再次购买
   async buyagain(row){
      console.log(row);
      const res = await getAgain({code:row.ordersCode})
      console.log(res);
      if(res.status){
      let routeData =  this.$router.resolve({
        path: '/buyAgain',
        query: { ordersCode: row.ordersCode }
      })
      window.open(routeData.href, '_blank')
      }

    }
  }
}
</script>

<style lang="less" scoped>
.box {
  width: 95%;
  max-height: 728px;
  // height: 728px;
  overflow-y: scroll;
  margin: 0 auto;
  .top {
    text-align: center;
    margin: 0 auto;
    height: 100%;
    width: 100%;
    display: flex;
    span {
      cursor: pointer;
      flex: 1;
      font-weight: 700;
      font-size: 16px;
      text-align: center;
    }
    .color {
      color: rgb(217, 0, 27);
    }
  }

  .mind {
        background-color: #ffffff;
    margin-top: 20px;
    .mind-one-top {
      margin-top:20px ;
      // height:50px;
      span {
        display: inline-block;
        padding-top: 20px;
      }
    }
    .table {
      width: 98%;
      margin: 0 auto;
      .mendian {
        display: inline-block;
        margin-right: 5px;
      }
      .icon-a-lujing162 {
        color: rgb(18, 150, 219);
        font-size: 16px;
      }
      .one {
        width: 400px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .img {
          width: 150px;
          height: 100px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .img-rigth {
          margin-top: 20px;
          width: 300px;
          height: 100px;

          .tow {
            margin-top: 30px;
            span {
              margin: 0 3px;
            }
          }
        }
      }
    }
  }
}
.god {
  color: #377CF1;
  display: inline-block;
  width: 64px;
  height: 40px;
  border-bottom: 1px solid #377CF1;
}
.god:hover{
   transition: border-bottom .5s;
   border-bottom: 4px solid #377CF1;
}
.search {
  margin-left: 20px;
  display: inline-block;
  width: 80px;
  height: 30px;
  background: #377CF1;
  border-radius: 3px;
  color: white;
  text-align: center;
  line-height: 30px;
}
.reset{
  background: #FFFFFF;
  border: 1px solid #377CF1;  
  color: #377CF1;
}

.danjia {
  font-weight: 700;
}
.icon-shangcheng {
  margin-left: 20px;
  margin-right: 5px;
  color: red;
}
.icon-a-lujing153 {
  color: #47c460;
}
.icon-a-ziyuan5 {
  color: #ff8a24;
}
.icon-a-ziyuan4 {
  color: #24b4ff;
}
 .icon-a-ziyuan21 {
   color: #ff3e3e;
}
.safeguard{
  display: flex;
  justify-content: left;
  align-items: center;
  // margin-top: 14px;
  li{
    display: flex;
    justify-content: space-around;
    margin-right: 5px;
  }
}
.fahuo {
  width: 80px;
  height: 30px;
  line-height: 30px;
  margin-left: 30px;
  margin-top: 10px;
  background: #e90d0d;
  opacity: 1;
  border-radius: 2px;
  color: white;
}
.fahuos {
  width: 80px;
  background: #e90d0d;
  font-weight: 700;
}
// .dsadas {
//   margin-top: 70px;
//   border-bottom: 1px solid rgb(232, 234, 236);
//   padding: 0 !important;
//   margin: 0 !important;
//   width: 100%;
//   height: 100px;
//   color: red;
// }
.icon-a-lujing296 {
  display: inline-block;
  color: #A8A8A8;
  cursor: pointer;
    i{
    color: #505050;
    padding-left: 2px;
  }
}
.icon-a-2 {
  font-size: 13px;
  color: #A8A8A8;
  cursor: pointer;
    i{
    color: #505050;
    padding-left: 3px;
  }
}
.ycj {
  background: #47c460;
  border-radius: 2px;
  line-height: 16px;
  color: #ffffff;
  opacity: 1;
  text-align: center;
  margin-right: 4px;
}

.fh {
  cursor: pointer;
  width: 80px;
  height: 30px;
  background: #377CF1;
  opacity: 1;
  border-radius: 2px;
  color: #ffffff;
  text-align: center;
  line-height: 30px;
  margin-bottom: 10px;
}
.fg{
  background: none;
  color: rgb(0, 116, 255);
  width: 70px;
  height: 22px;
  line-height: 22px;
}
.btn{
  width: 90px;
  
  height: 30px;
}
.mr30{
  margin-right: 30px;
}
.yes {
  width: 70px;
  height: 30px;
}
.ccc {
  font-weight: 700;
  line-height: 0px;
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
/deep/ .vxe-table--render-default.border--full .vxe-body--column{
      background-image:none;
      border: 1px solid #ccc;
      border-left:none ;
      border-top: none;
      background-repeat:no-repeat;
      background-size:none;
      background-position:none
}
/deep/ .vxe-table--render-default.border--full .vxe-body--column:nth-child(-n+4){
  border-right: none;
}
/deep/ .vxe-table--render-default.vxe-body--column:last-child{
  border: none;
}
/deep/ .vxe-table--render-default.border--full .vxe-body--column.aaaa{
  // border-right: none;
  padding: none !important;
}
.cc{
  text-align: left;
}

.rowBox{
height:100%;
width:100%;
text-align: left;
margin-left:25px;
position: relative;
padding: 0;

}
.pos{
  position: absolute;
  left: -25px;
  top: 10px;
}
.select{
  margin-top: 15px;
  display: flex;
  align-items: center;
  padding: 15px 9px;
  // border: 1px solid #ccc;
  width: 100%;
  height: 60px;
  background: #FFFFFF;
  box-shadow:2px 2px 10px 3px rgba(104, 104, 104, 0.1);
  opacity: 1;
  border-radius: 0px;
}
// /deep/.vxe-body--expanded-cell{
//   max-height: 338px;
//   overflow-y: auto;
// }
/*滚动条整体粗细样式*/
// /deep/::-webkit-scrollbar {
//     /*高宽分别对应横竖滚动条的尺寸*/
//     width: 8px;
//     height: 8px;
// }

// /*滚动条里面小方块*/
// /deep/::-webkit-scrollbar-thumb {
//     // border-radius: 10px !important;
//     box-shadow: inset 0 0 5px rgba(51, 51, 51, 0.2) !important;
//     /* 颜色 */
//     /* background:#b6b6b6!important; */
//     /* 线性渐变背景 */
//     background-image: #f8f1f1;
// }

// /*滚动条轨道*/
// /deep/::-webkit-scrollbar-track {
//     // border-radius: 10px !important;
//     box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2) !important;
//     background: #EDEDED !important;
// }
.w11{
  display: flex;
  justify-content: space-between;
  .w12{
   width: 60% ;
    max-width:250px;
  //     .w14{
  //   padding-top: 3%;
  // }
  }
  .w13{
    padding-top: 4%;
    padding-right: 3%;
  }

}
.route{
  width: 90px;
  display: block;
  margin: 0px auto;
  color: #fff;
  background-color: #377CF1;
  margin-top: 10px;
  padding: 5px 0;
  border-radius: 4px;
}
/deep/.vxe-pager--sizes{
  display: none;
}
</style>
